import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Card principal de Configurações (envolve menu + conteúdo).
 *
 * Light: branco elevado sobre #F8FAFC
 * Dark: #27272A elevado sobre #18181B
 */
export function SettingsShell({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="settings-shell"
      className={cn(
        "flex min-h-0 flex-1 gap-4 overflow-hidden rounded-2xl border border-[#E5E7EB] bg-white p-4 shadow-sm transition-colors duration-200 md:gap-6 md:p-5 dark:border-[#3F3F464D] dark:bg-[#27272A] dark:shadow-none",
        className
      )}
      {...props}
    />
  );
}

/**
 * Painel interno da área de conteúdo (fora do menu lateral).
 *
 * Light: #F8FAFC (recesso sutil no card branco)
 * Dark: #18181B (recesso sutil no card #27272A)
 */
export function SettingsContentPanel({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="settings-content-panel"
      className={cn(
        "min-h-full w-full min-w-0 rounded-2xl border border-[#E5E7EB] bg-[#F8FAFC] p-5 shadow-sm transition-colors duration-200 md:p-6 dark:border-[#3F3F464D] dark:bg-[#18181B] dark:shadow-none",
        className
      )}
      {...props}
    />
  );
}

export default SettingsContentPanel;
